import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import camelCase from 'lodash/camelCase';
import isEmpty from 'lodash/isEmpty'; // import { email as emailValidator, maxLength, required, sameAs } from 'vuelidate/lib/validators'

import { get, sync } from 'vuex-pathify';
import { anniversary, isBeforeDate, isValidEmail, isValidForMask, isValidDate } from '@/functions/validators';
import { mdRender } from "../../functions/remarkable";
export default {
  name: 'Checkout',
  data: function data() {
    return {
      cardHeight: 240,
      cardWidth: 480,
      checkoutFormValid: false,
      contactRequested: false,
      email: '',
      formRef: 'checkoutForm',
      formValues: {},
      // probably improve this later
      heading: '',
      message: '',
      pageHidden: true,
      // Hide page in case we redirect
      privacyPolicyAccepted: false,
      signUpSelected: false,
      showRequestContact: false,
      showPrivacyPolicy: false,
      submitAttempted: false,
      voucherClaimed: false,
      recaptchaInputChecked: false,
      recaptchaValidated: false
    };
  },
  computed: _objectSpread(_objectSpread({}, sync('responses', ['failedToSubmit', 'sending'])), {}, {
    bgImage: get('theme/bgImage'),
    dangerColor: get('theme/theme@dangerColor'),
    hasComplaint: get('answers/hasComplaint'),
    logo: get('theme/logo'),
    primaryColor: get('theme/theme@primaryColor'),
    subscriptionEnabled: get('surveys/subscriptionEnabled'),
    surveyInProgress: sync('surveys/surveyInProgress'),
    survey: get('questions/getSurvey'),
    voucher: get('checkIn/voucher@selected'),
    submitted: get('responses/submitted'),
    dataCapture: get('config/config@dataCapture'),
    complaints: get('config/config@complaints'),
    hasConnectivity: get('settings/hasConnectivity'),
    isApp: get('config/isApp'),
    recommendationPermitted: get('answers/recommendationPermitted'),
    recommendationRulePassed: get('answers/recommendationRulePassed'),
    isAiValid: get('responses/isAiValid'),
    useRecaptcha: function useRecaptcha() {
      return !!process.env.RECAPTCHA_KEY && !this.isApp; // turned off for the automation server so need to check if is in use
    },
    iconColour: function iconColour() {
      return this.$store.getters['theme/theme'].dangerColor;
    },
    // visibility logic // *******************
    showAcceptPrivacyPolicy: function showAcceptPrivacyPolicy() {
      // Positive survey (no complaint), no voucher, subscribe on
      if (!this.hasComplaint && !this.hasVoucher && this.subscriptionEnabled) {
        return true;
      }

      return this.signUpSelected;
    },
    showComplaintsForm: function showComplaintsForm() {
      return this.hasComplaint;
    },
    showNewsletterSignUpCheckbox: function showNewsletterSignUpCheckbox() {
      // Data capture not enabled
      if (!this.dataCapture.enabled) {
        return false;
      } // Positive survey, has voucher, subscribe on


      if (!this.hasComplaint && this.hasVoucher && this.subscriptionEnabled) {
        return true;
      } // Positive survey, has voucher, subscribe off


      if (!this.hasComplaint && this.hasVoucher && !this.subscriptionEnabled) {
        return false;
      } // Positive survey, no voucher, subscribe on


      if (!this.hasComplaint && !this.hasVoucher && this.subscriptionEnabled) {
        return false;
      }

      return this.subscriptionEnabled;
    },
    showNewsletterForm: function showNewsletterForm() {
      return !this.hasComplaint && !this.hasVoucher || this.signUpSelected;
    },
    showVoucher: function showVoucher() {
      // We will only want the voucher section to show if the survey has a voucher to show and there is no complaint
      return this.hasVoucher && !this.hasComplaint;
    },
    complaintsConfig: function complaintsConfig() {
      var config = cloneDeep(this.complaints);
      var fields = [];
      config.fields.forEach(function (field) {
        // for each field validation needs to be constructed
        field.key = camelCase(field.name);

        if (field.display) {
          fields.push(field);
        }
      });
      config.fields = fields;
      return config;
    },
    complaintFields: function complaintFields() {
      var _this$complaintsConfi;

      var fields = cloneDeep(((_this$complaintsConfi = this.complaintsConfig) === null || _this$complaintsConfi === void 0 ? void 0 : _this$complaintsConfi.fields) || []);

      for (var i in fields) {
        // if signup selected then we want to override any fields required values with the required values from dataCapture fields
        if (this.showNewsletterForm && !fields[i].required) {
          for (var index in this.dataCapture.fields || []) {
            if (this.dataCapture.fields[index].name == fields[i].name) {
              fields[i].required = this.dataCapture.fields[index].required;
              break; // Stop extra loops through occurring of the dataCaptureFields.
            }
          }
        }

        fields[i].rules = this.getRules(fields[i]);
        fields[i].mask = this.getMask(fields[i]); // set visibility of field based on if the survey has a complaint

        fields[i].isVisible = this.hasComplaint;
      }

      return fields;
    },
    dataCaptureConfig: function dataCaptureConfig() {
      var _this = this;

      var config = cloneDeep(this.dataCapture);
      var fields = []; // If the dataCapture has not been set in Admin, the DB will not have any values for dataCapture.
      // We therefore need to provide the required default email field in this instance.

      if (!config.fields.length) {
        config.fields = [{
          display: true,
          isVisible: true,
          key: 'email',
          maxLength: null,
          minLength: null,
          name: 'email',
          required: true,
          type: 'email'
        }];
      }

      config.fields.forEach(function (field) {
        var obj = null;

        if (field.name == 'email') {
          field.isVisible = !_this.hasComplaint || _this.showNewsletterForm || _this.voucherClaimed; // email for dataCapture should always be required, make sure this is the case by setting to true

          field.required = true;
        } else {
          // set visibility of field on if the newsletter form fields should be displayed
          field.isVisible = _this.showNewsletterForm;
        } // we dont want to have any cross over with the complaint fields that are shown so need to check what fields overlap with complaints


        if (!obj && _this.hasComplaint) {
          obj = _this.complaintsConfig.fields.find(function (o) {
            return o.name === field.name;
          });
        } // only push fields that don't overlap with complaints


        if (!obj || !obj.display) {
          field.key = camelCase(field.name);
          fields.push(field);
        }
      });
      config.fields = fields;
      return config;
    },
    dataCaptureFields: function dataCaptureFields() {
      var fields = this.dataCaptureConfig ? cloneDeep(this.dataCaptureConfig.fields) : [];

      for (var i in fields) {
        fields[i].rules = this.getRules(fields[i]);
        fields[i].mask = this.getMask(fields[i]);
      }

      return fields;
    },
    dataCaptureDisplayableFields: function dataCaptureDisplayableFields() {
      return this.dataCaptureFields.filter(function (f) {
        return f.display;
      });
    },
    complaintsDisplayableFields: function complaintsDisplayableFields() {
      return this.complaintFields.filter(function (f) {
        return f.display;
      });
    },
    formFields: function formFields() {
      var dataCaptureFields = this.dataCaptureDisplayableFields;
      var complaintFields = this.complaintsDisplayableFields;
      var shownFields = complaintFields.concat(dataCaptureFields);
      return shownFields;
    },
    contactFields: function contactFields() {
      var _this2 = this;

      // this needs to be from the localstorage not the form fields version of datacapture as that gets manipulated and some fields hidden
      var dcf = this.dataCapture.fields.filter(function (f) {
        return f.display;
      });
      var cf = this.complaintsDisplayableFields;
      var fields = {
        dataCapture: dcf.reduce(function (acc, field) {
          acc[camelCase(field.name)] = _this2.formValues[camelCase(field.name)];
          return acc;
        }, {}),
        complaints: cf.reduce(function (acc, field) {
          acc[camelCase(field.name)] = _this2.formValues[camelCase(field.name)];
          return acc;
        }, {})
      }; // if data capture enabled, ensure it is set as well

      if (this.formValues.email) {
        fields.dataCapture.email = fields.complaints.email = this.formValues.email;
      }

      return fields;
    },
    shouldSubmitDataCapture: function shouldSubmitDataCapture() {
      return this.showNewsletterForm;
    },
    hasVoucher: function hasVoucher() {
      return !!this.voucher;
    },
    voucherText: function voucherText() {
      var _this$voucher;

      return ((_this$voucher = this.voucher) === null || _this$voucher === void 0 ? void 0 : _this$voucher.text) || '';
    },
    scratchcardVoucherProps: function scratchcardVoucherProps() {
      return this.voucher ? {
        finishPercent: this.voucher.finishPercent,
        forceScratched: this.voucher.scratched,
        voucherText: this.voucher.text
      } : {};
    },
    privacyPolicy: function privacyPolicy() {
      var _this$survey;

      return ((_this$survey = this.survey) === null || _this$survey === void 0 ? void 0 : _this$survey.dataCapture.termsText) || '';
    },
    submitDisabled: function submitDisabled() {
      // Certainly disable this button until the response has been submitted, otherwise
      // we're not saving the form result (survey/supplement) against anything!
      // button will always be disabled if recaptcha is enabled and recaptcha validation is false
      if (this.useRecaptcha && !this.recaptchaValidated) {
        return true;
      } // if a positive review them at least one of the options needs to be selected of the voucher or signup, however the user can submit a form if a complaint is present without selecting a voucher or signup


      if (!this.voucherClaimed && !this.signUpSelected && !this.hasComplaint) {
        return true;
      } // Check if the last submit was offline - if so enable the button


      if (this.isApp && this.$store.get('responses/current@offlineSurveyID') > 0) {
        return false;
      }

      if (!this.checkoutFormValid) {
        return true;
      }

      if (!this.submitted) {
        return true;
      }

      if (!this.submitAttempted) {
        return false;
      }

      return !this.validated;
    },
    validated: function validated() {
      return this.checkoutFormValid && (!this.signUpSelected || this.privacyPolicyAccepted);
    },
    skipSharePage: function skipSharePage() {
      return this.isApp && (this.hasComplaint || !this.hasConnectivity);
    }
  }),
  watch: {
    formValues: {
      handler: function handler() {
        // Re-validate forms after a change to their input contents.
        // We've added no-error-focus to the parent q-forms' default behaviours will be to
        // automatically change focus to the first invalid field. This isn't desired behaviour
        // as if you're typing in a later input it will switch the focus to a different input -
        // which means you can never type in the lower inputs.
        this.validateIfSubmitAttempted(); // Before the user has tried to submit for a first time we want to check that the inputs
        // with a value have a correct value
        // Once they have tried to submit a form then we can rely on the whole form validation

        if (!this.submitAttempted) {
          this.validateFilled(this.formRef);
        }
      },
      deep: true
    },
    hasConnectivity: {
      handler: function handler(connected) {
        this.useRecaptcha = connected && !!process.env.RECAPTCHA_KEY;
      }
    },
    formFields: {
      handler: function handler() {
        var _this3 = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this3.resetValidation();

                case 2:
                  if (!_this3.submitAttempted) {
                    _this3.validateFilled(_this3.formRef);
                  }

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
    }
  },
  mounted: function mounted() {
    this.beforeShow();
  },
  methods: {
    beforeShow: function beforeShow() {
      this.$store.dispatch('checkIn/selectVoucher'); // Prevent access through URL if there's no survey in progress

      if (!this.surveyInProgress) {
        this.$router.push('/'); // Redirect to index page

        return;
      } // If positive survey (no complaint) + no voucher + no subscribe - redircet to share


      if (!this.hasComplaint && !this.hasVoucher && !this.subscriptionEnabled) {
        this.routeToNextPage(true);
        return;
      }

      this.resetForm(); // Configure heading and message

      if (!this.hasComplaint && !this.hasVoucher && this.subscriptionEnabled) {
        this.signUpSelected = true;
        this.heading = this.$lang('subscribe_only_header');
        this.message = this.$lang('subscribe_only_text');
      } else if (this.hasComplaint) {
        this.heading = this.$lang('we_are_sorry_header') || this.$t('checkout.weAreSorryHeader');
        this.message = this.$lang('we_are_sorry_text') || this.$t('checkout.weAreSorryText');
      } else {
        this.heading = this.$lang('thank_you_header') || this.$t('checkout.thankYouHeader');

        if (this.hasVoucher) {
          this.message = this.$lang('thank_you_voucher_help') || this.$t('checkout.thankYouVoucher');
        }
      }

      if (this.hasComplaint) {
        var hasRequiredFields = this.complaintFields.some(function (field) {
          return field.required;
        });
        this.checkoutFormValid = !hasRequiredFields;
      }

      this.pageHidden = false; // Display page
    },
    resetForm: function resetForm() {
      this.showRequestContact = false;
      this.resetValidation();
    },
    noThanks: function noThanks() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.$store.get('responses/current@offlineSurveyID') > 0)) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return _this4.$store.dispatch('responses/supplement');

              case 3:
                if (!_this4.failedToSubmit) {
                  _context2.next = 6;
                  break;
                }

                _this4.$store.dispatch('errors/display', {
                  error: _this4.$t('survey.checkoutError')
                });

                return _context2.abrupt("return");

              case 6:
                _this4.routeToNextPage();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getRules: function getRules(field) {
      var _this5 = this;

      var rules = []; // if required, add required

      if (field.required) {
        rules.push(function (v) {
          return !!v || _this5.$t('common.validation.required');
        });
      } // if maxLength set, add maxLength


      if (field.maxLength) {
        rules.push(function (v) {
          return !v || v.length <= parseInt(field.maxLength) || _this5.$tc('common.validation.max', parseInt(field.maxLength));
        });
      } // if minLength set, add minLength


      if (field.minLength) {
        rules.push(function (v) {
          return !v || v.length >= parseInt(field.minLength) || _this5.$tc('common.validation.min', parseInt(field.minLength));
        });
      } // set validation based on type // ****
      // if an email, push email


      if (field.type === 'email') {
        rules.push(function (v) {
          if (v) {
            return isValidEmail(v) || _this5.$t('common.validation.email');
          }
        });
      } // if a date, validate by mask


      if (field.type === 'date_MMDD') {
        rules.push(function (v) {
          return !v || isValidForMask(v, '##/##') || _this5.$t('common.validation.DDMM');
        });
        rules.push(function (v) {
          return !v || isValidDate(v, 'DD/MM') || _this5.$t('common.validation.DDMM');
        });
        rules.push(function (v) {
          return !v || anniversary(v) || _this5.$t('common.validation.DDMM');
        });
      }

      if (field.type === 'date_YYYYMMDD') {
        rules.push(function (v) {
          return !v || isValidDate(v, 'DD/MM/YYYY') || _this5.$t('common.validation.DDMMYYYY');
        });
        rules.push(function (v) {
          return !v || isValidForMask(v, '##/##/####') || _this5.$t('common.validation.DDMMYYYY');
        });
        rules.push(function (v) {
          return !v || !isValidDate(v, 'DD/MM/YYYY') || isBeforeDate(v) || _this5.$t('common.validation.futureDateNotAllowed');
        });
      }

      return rules;
    },
    getMask: function getMask(field) {
      if (field.type === 'date_MMDD') {
        return '##/##';
      }

      if (field.type === 'date_YYYYMMDD') {
        return '##/##/####';
      }

      return;
    },
    trimField: function trimField(field) {
      this.formValues[field.key] = this.formValues[field.key] ? this.formValues[field.key].trim() : this.formValues[field.key];
    },
    setFormValue: function setFormValue(e, key) {
      if (e === '__/__/____' && key === 'dateOfBirth' || e === '__/__' && key === 'birthday') {
        e = '';
      }

      this.$set(this.formValues, key, e);
    },
    handlePrivacyPolicyInput: function handlePrivacyPolicyInput(e) {
      this.privacyPolicyAccepted = e;
      this.validateIfSubmitAttempted();
    },
    handleSignUpSelected: function handleSignUpSelected(e) {
      this.signUpSelected = e;
      this.validateIfSubmitAttempted();
    },
    handleVoucherClaimed: function handleVoucherClaimed(e) {
      this.voucherClaimed = e;
      this.validateIfSubmitAttempted();
    },
    validateIfSubmitAttempted: function validateIfSubmitAttempted() {
      if (this.submitAttempted) {
        this.validate();
      }
    },
    handleValidationError: function handleValidationError() {
      this.checkoutFormValid = false;
    },
    handleValidationSuccessful: function handleValidationSuccessful() {
      this.checkoutFormValid = true;
    },
    submitForm: function submitForm() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var payload, _this6$survey$dataCap;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this6.validated) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                payload = {}; // if voucher claimed and email available

                if (_this6.voucherClaimed && _this6.formValues.email && _this6.voucher) {
                  payload.voucher = {
                    email: _this6.formValues.email,
                    selected: _this6.voucher.type
                  };
                } // if dataCapture should be sent


                if (_this6.shouldSubmitDataCapture) {
                  payload.dataCapture = {
                    terms: {
                      version: ((_this6$survey$dataCap = _this6.survey.dataCapture) === null || _this6$survey$dataCap === void 0 ? void 0 : _this6$survey$dataCap.termsVersion) || '',
                      datetime: moment().format('YYYY-MM-DD HH:mm:ss')
                    },
                    fields: _this6.contactFields.dataCapture
                  };
                } // if complaint available


                if (_this6.hasComplaint) {
                  payload.complaint = {
                    raised: _this6.hasComplaint,
                    fields: _this6.contactFields.complaints
                  };
                }

                if (isEmpty(payload)) {
                  _context3.next = 12;
                  break;
                }

                Logger.debug('Save checkout form data:', payload);
                _context3.next = 10;
                return _this6.$store.dispatch('responses/supplement', payload);

              case 10:
                Logger.debug('Save checkout form data:', payload);

                if (!_this6.failedToSubmit) {
                  _this6.routeToNextPage();
                } else {
                  _this6.$store.dispatch('errors/display', {
                    error: _this6.$t('survey.checkoutError')
                  });
                }

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleSubmit: function handleSubmit() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var self, submit;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this7.submitAttempted = true;
                self = _this7;

                submit = function submit(v) {
                  if (v) {
                    self.submitForm();
                  }
                };

                _this7.validate(submit);

                setTimeout(function () {
                  return _this7.scrollToValidationError();
                }, 100);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    resetValidation: function resetValidation(reValidate, callback) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this8.$refs[_this8.formRef].resetValidation();

                if (reValidate) {
                  _this8.validate(callback);
                }

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    validate: function validate(callback) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var self;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                self = _this9;

                _this9.$nextTick(function () {
                  self.validateAll(callback);
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    scrollToValidationError: function scrollToValidationError() {
      var errorInputField = document.querySelector('.q-field--error');

      if (errorInputField) {
        errorInputField.scrollIntoView({
          behavior: 'smooth'
        });
      }
    },
    validateForm: function validateForm(form, callback) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var self;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                self = _this10;

                if (!_this10.$refs[form]) {
                  _context7.next = 5;
                  break;
                }

                return _context7.abrupt("return", new Promise(function (resolve) {
                  self.$refs[form].validate().then(function (r) {
                    if (callback) {
                      callback(r);
                    }

                    resolve(r);
                  });
                }));

              case 5:
                return _context7.abrupt("return", true);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    validateFilled: function validateFilled(form) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var errors, inputsWithValues, formElements;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (_this11.$refs[form]) {
                  errors = 0;
                  inputsWithValues = [];
                  formElements = _this11.$refs[form].$children; // Only want to check against form inputs that have a value

                  formElements.forEach(function (input) {
                    if (input.value) {
                      inputsWithValues.push(input);
                    }
                  }); // Check that each filled input is valid, if not that increase the errors value

                  inputsWithValues.forEach(function (input) {
                    if (!input.validate()) {
                      errors++;
                    }
                  }); // If no errors (0) then will be true, otherwise set the checkoutFormValid value to false

                  _this11.checkoutFormValid = errors === 0;
                }

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    validateAll: function validateAll(callback) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var validations;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // collect an array of all validations (stored as promises)
                Logger.debug('formRef', _this12.$refs);
                validations = []; //

                validations.push(_this12.validateForm(_this12.formRef)); // await all validation responses, then submit if all validations pass
                //? Shoudl this be await'ed then?

                Promise.all(validations).then(function (values) {
                  var valid = values.reduce(function (acc, v) {
                    if (!acc) {
                      return false;
                    }

                    return v;
                  }, true);
                  Logger.debug(valid ? _this12.$t('common.validation.validationSuccessful') : _this12.$t('common.validation.validationFailed')); // set the checkoutFormValid value to the valid state

                  _this12.checkoutFormValid = valid; // if callback available, call it

                  if (callback) {
                    callback(valid);
                  }
                }).catch(function (e) {
                  Logger.error(e);
                });

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    handleRecaptcha: function handleRecaptcha() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (_this13.recaptchaInputChecked) {
                  _context10.next = 14;
                  break;
                }

                _context10.prev = 1;
                _context10.next = 4;
                return _this13.$recaptchaLoaded();

              case 4:
                _context10.next = 6;
                return _this13.$recaptcha('login');

              case 6:
                // currently we do not verify the recaptcha with the backend side of the recaptcha instance, this can be done but requires setup within the google cloud account and was not required for the ticket, in future if we do include the verification of the token then will need to verify first before setting the recaptcha validate to true
                _this13.recaptchaValidated = true;
                _context10.next = 12;
                break;

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10["catch"](1);
                _this13.recaptchaValidated = false;

              case 12:
                _context10.next = 15;
                break;

              case 14:
                // if unticking the recaptcha checkbox then we need to set validated to false
                _this13.recaptchaValidated = false;

              case 15:
                _this13.recaptchaInputChecked = !_this13.recaptchaInputChecked;

              case 16:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[1, 9]]);
      }))();
    },
    routeToNextPage: function routeToNextPage() {
      var alwaysShare = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var permitSharing = alwaysShare || !this.skipSharePage;
      var shareRoute = this.isAiValid && this.recommendationPermitted && this.recommendationRulePassed ? '/recommend' : '/share';

      if (!this.recommendationPermitted || !this.recommendationRulePassed || !this.isAiValid) {
        var reason = 'There is not enough information to generate an informed response';

        if (!this.recommendationRulePassed) {
          reason = 'Ai recommendation rules not met';
        }

        if (!this.recommendationPermitted) {
          reason = 'Ai recommendation not configured for survey';
        }

        console.info("Ai recommendation skipped: \n ".concat(reason));
      }

      this.$router.push(permitSharing ? shareRoute : '/thank-you');
    },
    handleScratch: function handleScratch(scratched) {
      this.voucherClaimed = scratched;
    },
    renderText: function renderText(text) {
      return mdRender(text);
    }
  }
};